import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'

import { cn } from '@/lib/utils'

export interface SearchOptionsGuideDialogProps {
  isOpen: boolean
  onClose: VoidFunction
}

export const SearchOptionsGuideDialog = ({ isOpen, onClose }: SearchOptionsGuideDialogProps) => {
  const handleChangeOpen = (open: boolean) => {
    if (!open) {
      onClose()
      return
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleChangeOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>OR / AND</DialogTitle>
          <DialogDescription className={cn('sr-only')}>Select how you want to search for the tags.</DialogDescription>
        </DialogHeader>

        <div className={cn('flex flex-col space-y-6')}>
          <p>
            <b>OR:</b> The table will show results that match any of the selected options.
            <br />
            Example: Selecting &quot;A OR B&quot; will display all data points that contain either A or B (or both).
          </p>
          <p>
            <b>AND:</b> The table will show results that meet all selected conditions.
            <br />
            Example: Selecting &quot;A AND B&quot; will display only data points that contain both A and B together.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  )
}
